module.exports = __webpack_public_path__ + "static/media/ItalicBlue.704f8b30.svg";